import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function Payments() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [labours,  setLabours]  = useState([]);
  const [loading,  setLoading]  = useState(false);
  const [fetching, setFetching] = useState(true);
  const [success,  setSuccess]  = useState(false);
  const [error,    setError]    = useState("");
  const [form, setForm] = useState({
    labourId: "",
    amount:   "",
    type:     "advance",
    remark:   "",
    date:     today(),   // only used for overtime
  });

  function today() {
    return new Date().toISOString().split("T")[0];
  }

  const navItems = [
    { label:"Dashboard",  emoji:"🏠", path:"/carpenter/dashboard" },
    { label:"My Labours", emoji:"👷", path:"/carpenter/labours" },
    { label:"Add Labour", emoji:"➕", path:"/carpenter/add-labour" },
    { label:"Attendance", emoji:"📋", path:"/carpenter/attendance" },
    { label:"Payments",   emoji:"💰", path:"/carpenter/payments", active:true },
    { label:"Salary",     emoji:"💵", path:"/carpenter/salary" },
  ];

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/carpenter/labours");
        setLabours(res.data.data || []);
      } catch(e) { console.error(e); }
      finally { setFetching(false); }
    })();
  }, []);

  const handleChange = (e) => {
    setError("");
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };

  const handleType = (val) => {
    setError("");
    setForm(f => ({ ...f, type: val }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const payload = {
        labourId: form.labourId,
        amount:   Number(form.amount),
        type:     form.type,
        remark:   form.remark,
      };
      // overtime ko date ke saath bhejo
      if (form.type === "overtime") payload.date = form.date;

      await api.post("/payment/pay", payload);
      setSuccess(true);
      setForm({ labourId:"", amount:"", type:"advance", remark:"", date:today() });
      setTimeout(() => setSuccess(false), 3500);
    } catch(err) {
      setError(err.response?.data?.message || "Payment failed. Please try again.");
    } finally { setLoading(false); }
  };

  const selectedLabour = labours.find(l => l._id === form.labourId);

  // Advance aur Overtime — salary wala remove
  const payTypes = [
    { value:"advance",  label:"Advance",  emoji:"💸", color:"#D97706", bg:"#FEF3C7", border:"#FDE68A",
      desc:"Amount paid in advance" },
    { value:"payment",  label:"Payment",  emoji:"💵", color:"#059669", bg:"#D1FAE5", border:"#A7F3D0",
      desc:"Salary / weekly / final pay" },
    { value:"overtime", label:"Overtime", emoji:"⏱",  color:"#0369A1", bg:"#DBEAFE", border:"#93C5FD",
      desc:"Adds to that day's daily rate" },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        @keyframes fadeUp { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }
        @keyframes popIn  { from{opacity:0;transform:scale(0.9)}       to{opacity:1;transform:scale(1)} }
        @keyframes spin   { to{transform:rotate(360deg)} }
        @keyframes slideDown { from{opacity:0;transform:translateY(-8px)} to{opacity:1;transform:translateY(0)} }
        *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
        body { font-family:'Plus Jakarta Sans',sans-serif; background:#FAF7F4; }
        .sidebar { width:220px; flex-shrink:0; background:#fff; border-right:1.5px solid #E7E5E4; padding:24px 14px; display:flex; flex-direction:column; gap:6px; position:sticky; top:0; height:100vh; overflow-y:auto; }
        .topbar  { display:none; }
        .hamburger { display:none; align-items:center; justify-content:center; width:40px; height:40px; border-radius:10px; border:1.5px solid #E7E5E4; background:#fff; cursor:pointer; flex-shrink:0; }
        .sidebar-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.4); z-index:40; }
        .nav-btn { display:flex; align-items:center; gap:9px; width:100%; padding:10px 12px; border-radius:10px; border:none; background:none; font-family:'Plus Jakarta Sans',sans-serif; font-size:14px; font-weight:600; color:#78716C; cursor:pointer; transition:background .15s,color .15s; text-align:left; }
        .nav-btn:hover,.nav-btn.active { background:#FEF3C7; color:#D97706; }
        .nav-btn.danger:hover { background:#FEF2F2; color:#DC2626; }
        .form-input { width:100%; padding:12px 14px; border:1.5px solid #E7E5E4; border-radius:12px; font-family:'Plus Jakarta Sans',sans-serif; font-size:14px; color:#1C1917; outline:none; background:#FFF7ED; transition:border-color .2s,box-shadow .2s; }
        .form-input:focus { border-color:#D97706; box-shadow:0 0 0 3px rgba(217,119,6,.1); }
        .form-input::placeholder { color:#A8A29E; }
        .form-input:disabled { opacity:.6; cursor:not-allowed; }
        .type-card { border-radius:14px; padding:16px; cursor:pointer; border:2px solid; transition:all .15s; flex:1; }
        .type-card:hover { transform:translateY(-1px); }
        .ot-info { animation:slideDown .2s ease; }
        @media (max-width:768px) {
          .sidebar { position:fixed; left:0; top:0; z-index:50; transform:translateX(-100%); transition:transform .28s ease; height:100%; }
          .sidebar.open { transform:translateX(0); }
          .sidebar-overlay.open { display:block; }
          .topbar { display:flex; align-items:center; gap:12px; padding:14px 16px; background:#fff; border-bottom:1.5px solid #E7E5E4; position:sticky; top:0; z-index:30; }
          .hamburger { display:flex; }
          .main-wrap { flex-direction:column !important; }
          .main-content { padding:16px !important; }
        }
        @media (min-width:769px) and (max-width:1100px) { .sidebar { width:190px; } }
      `}</style>

      <div className="main-wrap" style={{ display:"flex", minHeight:"100vh", fontFamily:"'Plus Jakarta Sans',sans-serif", backgroundColor:"#FAF7F4" }}>
        <div className={`sidebar-overlay ${sidebarOpen?"open":""}`} onClick={() => setSidebarOpen(false)} />

        {/* SIDEBAR */}
        <aside className={`sidebar ${sidebarOpen?"open":""}`}>
          <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"28px", padding:"0 4px" }}>
            <div style={{ width:"36px", height:"36px", background:"linear-gradient(135deg,#92400E,#D97706)", borderRadius:"10px", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <span style={{ fontSize:"18px" }}>🪚</span>
            </div>
            <div>
              <p style={{ fontWeight:"800", fontSize:"15px", color:"#1C1917" }}>Craftigo</p>
              <p style={{ fontSize:"11px", color:"#A8A29E", fontWeight:"500" }}>Carpenter Panel</p>
            </div>
          </div>
          <p style={{ fontSize:"11px", fontWeight:"700", color:"#C4B5A4", letterSpacing:"0.7px", textTransform:"uppercase", padding:"0 6px", marginBottom:"6px" }}>Menu</p>
          {navItems.map(n => (
            <button key={n.label} className={`nav-btn ${n.active?"active":""}`}
              onClick={() => { navigate(n.path); setSidebarOpen(false); }}>
              {n.emoji} {n.label}
            </button>
          ))}
          <div style={{ flex:1 }} />
          <div style={{ padding:"12px", background:"linear-gradient(135deg,#FEF3C7,#FFF7ED)", borderRadius:"12px", border:"1px solid #FDE68A", marginBottom:"10px" }}>
            <p style={{ fontSize:"12px", fontWeight:"700", color:"#92400E" }}>🪚 Carpenter</p>
            <p style={{ fontSize:"11px", color:"#B45309", marginTop:"2px" }}>Manage your team</p>
          </div>
          <button className="nav-btn danger" onClick={() => { localStorage.clear(); navigate("/login"); }}>🚪 Logout</button>
        </aside>

        {/* RIGHT */}
        <div style={{ flex:1, display:"flex", flexDirection:"column", minWidth:0 }}>
          <div className="topbar">
            <button className="hamburger" onClick={() => setSidebarOpen(true)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6"  x2="21" y2="6"  stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="18" x2="21" y2="18" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <span style={{ fontWeight:"800", fontSize:"16px", color:"#1C1917" }}>💰 Payments</span>
          </div>

          <main className="main-content" style={{ padding:"32px", flex:1, overflowY:"auto" }}>
            <div style={{ maxWidth:"560px", margin:"0 auto" }}>

              {/* Header */}
              <div style={{ marginBottom:"24px", animation:"fadeUp .35s ease both" }}>
                <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
                  <div style={{ width:"44px", height:"44px", borderRadius:"12px", background:"linear-gradient(135deg,#065F46,#059669)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"22px" }}>💰</div>
                  <div>
                    <h1 style={{ fontSize:"22px", fontWeight:"800", color:"#1C1917", letterSpacing:"-0.4px" }}>Make Payment</h1>
                    <p style={{ fontSize:"13px", color:"#A8A29E" }}>Record advance or overtime payment</p>
                  </div>
                </div>
              </div>

              {/* Success banner */}
              {success && (
                <div style={{ background:"linear-gradient(135deg,#D1FAE5,#A7F3D0)", border:"1.5px solid #A7F3D0", borderRadius:"14px", padding:"16px 20px", display:"flex", alignItems:"center", gap:"12px", marginBottom:"20px", animation:"popIn .3s ease" }}>
                  <span style={{ fontSize:"22px" }}>🎉</span>
                  <p style={{ fontSize:"14px", fontWeight:"700", color:"#065F46" }}>Payment recorded successfully!</p>
                </div>
              )}

              {/* Error banner */}
              {error && (
                <div style={{ background:"#FEF2F2", border:"1.5px solid #FECACA", borderRadius:"14px", padding:"14px 18px", display:"flex", alignItems:"center", gap:"10px", marginBottom:"20px", animation:"popIn .25s ease" }}>
                  <span style={{ fontSize:"18px" }}>⚠️</span>
                  <p style={{ fontSize:"13px", fontWeight:"600", color:"#DC2626" }}>{error}</p>
                </div>
              )}

              <div style={{ background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"20px", padding:"28px", animation:"fadeUp .4s .05s ease both" }}>
                <form onSubmit={handleSubmit}>
                  <div style={{ display:"flex", flexDirection:"column", gap:"20px" }}>

                    {/* Labour select */}
                    <div>
                      <label style={{ fontSize:"12px", fontWeight:"700", color:"#44403C", display:"block", marginBottom:"7px" }}>
                        Select Labour <span style={{ color:"#DC2626" }}>*</span>
                      </label>
                      {fetching ? (
                        <div style={{ padding:"12px 14px", background:"#FFF7ED", border:"1.5px solid #E7E5E4", borderRadius:"12px", color:"#A8A29E", fontSize:"14px" }}>Loading…</div>
                      ) : (
                        <select name="labourId" value={form.labourId} onChange={handleChange}
                          required disabled={loading} className="form-input" style={{ cursor:"pointer" }}>
                          <option value="">— Choose a labour —</option>
                          {labours.map(l => (
                            <option key={l._id} value={l._id}>{l.name}</option>
                          ))}
                        </select>
                      )}
                      {selectedLabour && (
                        <div style={{ marginTop:"10px", background:"#FEF3C7", border:"1px solid #FDE68A", borderRadius:"10px", padding:"10px 14px", display:"flex", gap:"8px", alignItems:"center" }}>
                          <span style={{ fontSize:"16px" }}>👷</span>
                          <p style={{ fontSize:"13px", fontWeight:"600", color:"#92400E" }}>
                            {selectedLabour.name} — ₹{selectedLabour.dailyRate}/day
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Payment type — Advance / Overtime */}
                    <div>
                      <label style={{ fontSize:"12px", fontWeight:"700", color:"#44403C", display:"block", marginBottom:"10px" }}>
                        Payment Type
                      </label>
                      <div style={{ display:"flex", gap:"10px" }}>
                        {payTypes.map(pt => (
                          <div key={pt.value} className="type-card"
                            onClick={() => handleType(pt.value)}
                            style={{
                              background:   form.type===pt.value ? pt.bg  : "#fff",
                              borderColor:  form.type===pt.value ? pt.color : "#E7E5E4",
                              boxShadow:    form.type===pt.value ? `0 0 0 3px ${pt.color}22` : "none",
                            }}>
                            <p style={{ fontSize:"22px", marginBottom:"6px" }}>{pt.emoji}</p>
                            <p style={{ fontSize:"14px", fontWeight:"800", color:form.type===pt.value ? pt.color : "#1C1917" }}>
                              {pt.label}
                            </p>
                            <p style={{ fontSize:"11px", color:form.type===pt.value ? pt.color : "#A8A29E", fontWeight:"500", marginTop:"3px" }}>
                              {pt.desc}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* ── OVERTIME: date picker + info box ── */}
                    {form.type === "overtime" && (
                      <div className="ot-info">
                        <label style={{ fontSize:"12px", fontWeight:"700", color:"#44403C", display:"block", marginBottom:"7px" }}>
                          Select Date <span style={{ color:"#DC2626" }}>*</span>
                        </label>
                        <input className="form-input" type="date" name="date"
                          value={form.date} onChange={handleChange}
                          required disabled={loading} />

                        {/* Info box */}
                        <div style={{ marginTop:"10px", background:"#EFF6FF", border:"1.5px solid #BFDBFE", borderRadius:"12px", padding:"12px 14px", display:"flex", gap:"10px" }}>
                          <span style={{ fontSize:"18px", flexShrink:0 }}>ℹ️</span>
                          <div>
                            <p style={{ fontSize:"12px", fontWeight:"700", color:"#1E40AF" }}>How overtime is calculated?</p>
                            <p style={{ fontSize:"11px", color:"#3B82F6", marginTop:"3px", lineHeight:"1.5" }}>
                              The entered amount will be <strong>added</strong> to that day's daily rate.<br/>
                              It will show separately when generating salary.
                            </p>
                          </div>
                        </div>

                        {/* Preview: daily rate + overtime = total */}
                        {selectedLabour && form.amount && (
                          <div style={{ marginTop:"10px", background:"#DBEAFE", border:"1.5px solid #93C5FD", borderRadius:"12px", padding:"12px 16px" }}>
                            <p style={{ fontSize:"11px", fontWeight:"700", color:"#0369A1", marginBottom:"6px" }}>Total earning for that day:</p>
                            <div style={{ display:"flex", alignItems:"center", gap:"8px", flexWrap:"wrap" }}>
                              <span style={{ fontSize:"13px", fontWeight:"600", color:"#1C1917" }}>₹{selectedLabour.dailyRate}</span>
                              <span style={{ fontSize:"11px", color:"#64748B" }}>daily rate</span>
                              <span style={{ fontSize:"16px", color:"#0369A1", fontWeight:"800" }}>+</span>
                              <span style={{ fontSize:"13px", fontWeight:"600", color:"#1C1917" }}>₹{form.amount}</span>
                              <span style={{ fontSize:"11px", color:"#64748B" }}>overtime</span>
                              <span style={{ fontSize:"16px", color:"#059669", fontWeight:"800" }}>=</span>
                              <span style={{ fontSize:"15px", fontWeight:"800", color:"#059669" }}>
                                ₹{Number(selectedLabour.dailyRate) + Number(form.amount)}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Amount */}
                    <div>
                      <label style={{ fontSize:"12px", fontWeight:"700", color:"#44403C", display:"block", marginBottom:"7px" }}>
                        {form.type === "overtime" ? "Overtime Amount (₹)" : form.type === "payment" ? "Payment Amount (₹)" : "Advance Amount (₹)"}
                        <span style={{ color:"#DC2626" }}> *</span>
                      </label>
                      <div style={{ position:"relative" }}>
                        <span style={{ position:"absolute", left:"13px", top:"50%", transform:"translateY(-50%)", fontSize:"14px", fontWeight:"700", color:"#78716C", pointerEvents:"none" }}>₹</span>
                        <input className="form-input" name="amount" type="number" placeholder="0"
                          min="1" value={form.amount} onChange={handleChange}
                          required disabled={loading}
                          style={{ paddingLeft:"28px", fontSize:"18px", fontWeight:"700" }} />
                      </div>
                    </div>

                    {/* Remark */}
                    <div>
                      <label style={{ fontSize:"12px", fontWeight:"700", color:"#44403C", display:"block", marginBottom:"7px" }}>
                        Remark (optional)
                      </label>
                      <input className="form-input" name="remark" type="text"
                        placeholder={form.type==="overtime" ? "e.g. Night shift, Extra work…" : form.type==="payment" ? "e.g. Weekly pay, Final salary…" : "e.g. Festival bonus, Emergency…"}
                        value={form.remark} onChange={handleChange} disabled={loading} />
                    </div>

                    {/* Submit */}
                    <button type="submit" disabled={loading}
                      style={{ padding:"14px", background:loading?"#E7E5E4":form.type==="overtime"?"linear-gradient(135deg,#1E3A8A,#0369A1)":form.type==="payment"?"linear-gradient(135deg,#065F46,#059669)":"linear-gradient(135deg,#92400E,#D97706)", border:"none", borderRadius:"12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"15px", fontWeight:"800", color:loading?"#A8A29E":"#fff", cursor:loading?"not-allowed":"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:"8px", marginTop:"4px" }}>
                      {loading ? (
                        <>
                          <span style={{ width:"18px", height:"18px", border:"2.5px solid #C4B5A4", borderTop:"2.5px solid #78716C", borderRadius:"50%", animation:"spin .7s linear infinite", display:"inline-block" }} />
                          Processing…
                        </>
                      ) : form.type === "overtime"
                          ? `⏱ Record Overtime${form.amount ? " — ₹"+form.amount : ""}`
                          : form.type === "payment"
                            ? `💵 Record Payment${form.amount ? " — ₹"+form.amount : ""}`
                            : `💸 Record Advance${form.amount ? " — ₹"+form.amount : ""}`
                      }
                    </button>

                  </div>
                </form>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}